/**
 * Main Theme JavaScript
 *
 * @package CanadaAbroad
 */

(function() {
	'use strict';

	// Mobile Menu Toggle
	const mobileNavigation = document.getElementById('mobile-navigation');
	const mobileMenuToggles = document.querySelectorAll('[data-mobile-menu-toggle]');

	function setMobileMenuState(isOpen) {
		if (!mobileNavigation) return;

		const mobileHeaderBar = document.getElementById('mobile-header-bar');
		const isHeaderSticky = mobileHeaderBar && mobileHeaderBar.classList.contains('mobile-header-bar--sticky');

		if (isOpen) {
			mobileNavigation.classList.remove('hidden');
			mobileNavigation.classList.add('active');
			
			// If header bar is sticky, position menu below it
			if (isHeaderSticky && window.innerWidth <= 768) {
				const headerBarHeight = mobileHeaderBar.offsetHeight;
				mobileNavigation.style.cssText = 'position:fixed;top:' + headerBarHeight + 'px;left:0;right:0;width:100%;z-index:9999;max-height:calc(100vh - ' + headerBarHeight + 'px);overflow-y:auto;';
			} else {
				mobileNavigation.style.cssText = '';
			}
		} else {
			mobileNavigation.classList.remove('active');
			mobileNavigation.classList.add('hidden');
			mobileNavigation.style.cssText = '';
		}

		mobileMenuToggles.forEach((btn) => {
			btn.classList.toggle('active', isOpen);
			btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		});
	}

	if (mobileMenuToggles.length && mobileNavigation) {
		mobileMenuToggles.forEach((btn) => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				const isActive = mobileNavigation.classList.contains('active');
				setMobileMenuState(!isActive);
			});
		});

		// Close mobile menu when clicking outside
		document.addEventListener('click', function(event) {
			if (
				mobileNavigation.classList.contains('active') &&
				!mobileNavigation.contains(event.target) &&
				!Array.from(mobileMenuToggles).some((btn) => btn.contains(event.target))
			) {
				setMobileMenuState(false);
			}
		});

		// Close mobile menu on window resize if desktop
		window.addEventListener('resize', function() {
			if (window.innerWidth > 768) {
				setMobileMenuState(false);
			}
		});
	}

	// Smooth scroll for anchor links
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function(e) {
			const href = this.getAttribute('href');
			if (href !== '#' && href.length > 1) {
				const target = document.querySelector(href);
				if (target) {
					e.preventDefault();
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			}
		});
	});

	// Sticky Navigation on Scroll
	// Script loads in footer, so DOM is already ready
	(function initStickyNav() {
		const headerTop = document.getElementById('header-top');
		const stickyNav = document.getElementById('sticky-nav');
		const mobileHeaderBar = document.getElementById('mobile-header-bar');
		
		if (!headerTop || !stickyNav) {
			console.log('Sticky nav: Elements not found');
			return;
		}
		
		// Get the position where nav should become fixed
		let triggerPoint = headerTop.offsetHeight;
		let navHeight = stickyNav.offsetHeight;
		let isFixed = false;
		
		// Create placeholder to prevent content jump
		const placeholder = document.createElement('div');
		placeholder.style.cssText = 'display:none;height:' + navHeight + 'px;';
		stickyNav.after(placeholder);
		
		function handleScroll() {
			const scrollY = window.pageYOffset || document.documentElement.scrollTop;
			
			if (scrollY > triggerPoint && !isFixed) {
				// Fix the nav
				stickyNav.style.cssText = 'position:fixed;top:0;left:0;right:0;width:100%;z-index:9999;';
				stickyNav.classList.add('nav-is-fixed');
				placeholder.style.display = 'block';
				isFixed = true;
				
				// Make mobile header bar sticky too
				if (mobileHeaderBar && window.innerWidth <= 768) {
					// Get computed padding to preserve it
					const computedStyle = window.getComputedStyle(mobileHeaderBar);
					const paddingTop = computedStyle.paddingTop;
					const paddingBottom = computedStyle.paddingBottom;
					const paddingLeft = computedStyle.paddingLeft;
					const paddingRight = computedStyle.paddingRight;
					
					mobileHeaderBar.style.cssText = 'position:fixed;top:0;left:0;right:0;width:100%;max-width:100vw;z-index:9999;background:rgba(30,36,45,0.95);backdrop-filter:blur(10px);padding-top:' + paddingTop + ';padding-bottom:' + paddingBottom + ';padding-left:' + paddingLeft + ';padding-right:' + paddingRight + ';box-sizing:border-box;margin-left:0;margin-right:0;';
					mobileHeaderBar.classList.add('mobile-header-bar--sticky');
					
					// Recalculate height after applying styles
					const headerBarHeight = mobileHeaderBar.offsetHeight;
					// Set CSS variable for mobile navigation positioning
					document.documentElement.style.setProperty('--mobile-header-bar-height', headerBarHeight + 'px');
					// Add padding to body to prevent content jump
					document.body.style.paddingTop = headerBarHeight + 'px';
					// Prevent horizontal scroll when sticky
					document.documentElement.style.overflowX = 'hidden';
					document.body.style.overflowX = 'hidden';
				}
			} else if (scrollY <= triggerPoint && isFixed) {
				// Unfix the nav
				stickyNav.style.cssText = '';
				stickyNav.classList.remove('nav-is-fixed');
				placeholder.style.display = 'none';
				isFixed = false;
				
				// Unfix mobile header bar (only when still in mobile view)
				if (mobileHeaderBar && window.innerWidth <= 768) {
					clearMobileStickyState();
				}
			}

			// When in desktop view, always clear mobile sticky state if it was left on (e.g. user resized from mobile)
			if (mobileHeaderBar && window.innerWidth > 768 && mobileHeaderBar.classList.contains('mobile-header-bar--sticky')) {
				clearMobileStickyState();
			}
		}

		function clearMobileStickyState() {
			if (!mobileHeaderBar) return;
			mobileHeaderBar.classList.remove('mobile-header-bar--sticky');
			mobileHeaderBar.style.position = '';
			mobileHeaderBar.style.top = '';
			mobileHeaderBar.style.left = '';
			mobileHeaderBar.style.right = '';
			mobileHeaderBar.style.width = '';
			mobileHeaderBar.style.maxWidth = '';
			mobileHeaderBar.style.zIndex = '';
			mobileHeaderBar.style.background = '';
			mobileHeaderBar.style.backdropFilter = '';
			mobileHeaderBar.style.marginLeft = '';
			mobileHeaderBar.style.marginRight = '';
			mobileHeaderBar.style.boxSizing = '';
			document.documentElement.style.removeProperty('--mobile-header-bar-height');
			document.body.style.paddingTop = '';
			document.documentElement.style.overflowX = '';
			document.body.style.overflowX = '';
		}
		
		// Listen for scroll
		window.addEventListener('scroll', handleScroll, { passive: true });
		
		// Update trigger point on resize; clear mobile sticky state when switching to desktop
		window.addEventListener('resize', function() {
			if (window.innerWidth > 768 && mobileHeaderBar && mobileHeaderBar.classList.contains('mobile-header-bar--sticky')) {
				clearMobileStickyState();
			}
			if (!isFixed) {
				triggerPoint = headerTop.offsetHeight;
				navHeight = stickyNav.offsetHeight;
				placeholder.style.height = navHeight + 'px';
			}
		});
		
		// Check on load
		handleScroll();
	})();

	// Blog filter (category + sort) – AJAX, no reload, with loading state
	(function initBlogFilter() {
		const section = document.getElementById('js-all-posts');
		const catContainer = document.querySelector('.category-filter--responsive');
		const catSelect = document.getElementById('category-filter-select-responsive');
		const sortSelect = document.getElementById('date-sort-select-all');
		const postsList = document.getElementById('js-posts-list');
		const postsCount = document.getElementById('js-posts-count');
		const sentinel = document.getElementById('js-infinite-scroll-sentinel');
		const loadingEl = document.getElementById('js-posts-loading');

		if (!section || !postsList || !catSelect) return;
		const blogUrl = (section.getAttribute('data-blog-url') || '').replace(/\/?$/, '/');

		function getCurrentCatUrl() {
			const val = catSelect.value ? catSelect.value.trim() : '';
			return val || blogUrl;
		}
		function getCurrentSort() {
			return (sortSelect && sortSelect.value) ? sortSelect.value : 'date_desc';
		}
		function buildFetchUrl(catUrl, sortValue) {
			const u = (catUrl || blogUrl).trim();
			const sep = u.indexOf('?') !== -1 ? '&' : '?';
			return u + sep + 'sort=' + encodeURIComponent(sortValue || 'date_desc') + '&infinite=1';
		}
		function setLoading(show) {
			if (loadingEl) {
				loadingEl.classList.toggle('hidden', !show);
				loadingEl.classList.toggle('flex', show);
				if (postsList) postsList.style.visibility = show ? 'hidden' : '';
			}
		}
		function setActivePillByCat(catId) {
			if (!catContainer) return;
			const cat = String(catId || '0');
			catContainer.querySelectorAll('.category-filter-pill').forEach(function(p) {
				const isActive = (p.getAttribute('data-cat') || '0') === cat;
				p.classList.toggle('bg-primary-600', isActive);
				p.classList.toggle('text-white', isActive);
				p.classList.toggle('shadow-md', isActive);
				p.classList.toggle('bg-gray-100', !isActive);
				p.classList.toggle('text-gray-700', !isActive);
				p.setAttribute('aria-current', isActive ? 'page' : null);
			});
		}
		function updateFromResponse(html, targetCatUrl, targetSort) {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const wrap = doc.querySelector('.infinite-scroll-response');
			const append = (wrap && wrap.querySelector('.infinite-scroll-append')) || doc.querySelector('.infinite-scroll-append');
			if (!append) return;
			postsList.innerHTML = append.innerHTML;
			if (postsList.style) postsList.style.visibility = '';
			let cat = '';
			let sort = '';
			if (wrap && postsCount) {
				const found = wrap.getAttribute('data-found-posts');
				const maxPages = wrap.getAttribute('data-max-pages');
				const currentPage = wrap.getAttribute('data-current-page');
				cat = wrap.getAttribute('data-cat') || '';
				sort = wrap.getAttribute('data-sort') || 'date_desc';
				const singular = postsCount.getAttribute('data-label-singular') || 'Showing %d article';
				const plural = postsCount.getAttribute('data-label-plural') || 'Showing %d articles';
				const n = parseInt(found, 10) || 0;
				postsCount.textContent = (n === 1 ? singular : plural).replace('%d', n);
				if (sentinel) {
					sentinel.setAttribute('data-max-pages', maxPages || '1');
					sentinel.setAttribute('data-current-page', currentPage || '1');
					sentinel.setAttribute('data-cat', cat);
					sentinel.setAttribute('data-sort', sort);
				}
			}
			setActivePillByCat(cat);
			if (targetCatUrl) catSelect.value = targetCatUrl;
			if (sortSelect && targetSort) sortSelect.value = targetSort;
			try { window.dispatchEvent(new CustomEvent('blog-category-filter-updated')); } catch (e) {}
		}
		function loadPosts(catUrl, sortValue) {
			const url = buildFetchUrl(catUrl, sortValue);
			if (!url) return;
			setLoading(true);
			fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
				.then(function(r) { if (!r.ok) throw new Error('fetch'); return r.text(); })
				.then(function(html) {
					updateFromResponse(html, catUrl || getCurrentCatUrl(), sortValue || getCurrentSort());
				})
				.catch(function() {
					const u = new URL(blogUrl, window.location.origin);
					if (catUrl && catUrl.indexOf('cat=') !== -1) u.search = new URL(catUrl, window.location.origin).search;
					u.searchParams.set('sort', sortValue || 'date_desc');
					window.location.href = u.toString();
				})
				.finally(function() { setLoading(false); });
		}

		catSelect.addEventListener('change', function() {
			const val = this.value;
			if (val) loadPosts(val, getCurrentSort());
		});
		if (catContainer) {
			catContainer.querySelectorAll('.category-filter-pill').forEach(function(pill) {
				pill.addEventListener('click', function(e) {
					e.preventDefault();
					loadPosts(this.getAttribute('href'), getCurrentSort());
				});
			});
		}
		if (sortSelect) {
			sortSelect.addEventListener('change', function() {
				loadPosts(getCurrentCatUrl(), this.value);
			});
		}
	})();

	// Infinite scroll on blog index (horizontal layout only)
	(function initInfiniteScroll() {
		const sentinel = document.getElementById('js-infinite-scroll-sentinel');
		const container = document.getElementById('js-posts-list');
		if (!sentinel || !container) return;

		const baseUrl = (sentinel.getAttribute('data-base-url') || '').replace(/\/?$/, '/');
		const loadingEl = sentinel.querySelector('.infinite-scroll-loading');
		const endEl = sentinel.querySelector('.infinite-scroll-end');

		let loading = false;
		let done = false;

		function buildNextPageUrl() {
			const currentPage = parseInt(sentinel.getAttribute('data-current-page'), 10) || 1;
			const maxPages = parseInt(sentinel.getAttribute('data-max-pages'), 10) || 1;
			const catParam = sentinel.getAttribute('data-cat') || '';
			const sortParam = sentinel.getAttribute('data-sort') || '';
			const nextPage = currentPage + 1;
			if (nextPage > maxPages) return null;
			const path = nextPage === 1 ? baseUrl : baseUrl + 'page/' + nextPage + '/';
			const params = ['infinite=1'];
			if (catParam) params.push('cat=' + encodeURIComponent(catParam));
			if (sortParam) params.push('sort=' + encodeURIComponent(sortParam));
			const sep = path.indexOf('?') !== -1 ? '&' : '?';
			return path + sep + params.join('&');
		}

		function appendPosts(html) {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const wrap = doc.querySelector('.infinite-scroll-response');
			const append = wrap ? wrap.querySelector('.infinite-scroll-append') : doc.querySelector('.infinite-scroll-append');
			if (!append) return 0;
			const count = append.children.length;
			Array.prototype.forEach.call(append.children, function(node) {
				container.appendChild(node);
			});
			return count;
		}

		function loadNext() {
			if (loading || done) return;
			const url = buildNextPageUrl();
			if (!url) {
				done = true;
				if (loadingEl) loadingEl.classList.add('hidden');
				if (endEl) endEl.classList.remove('hidden');
				return;
			}
			loading = true;
			if (loadingEl) loadingEl.classList.remove('hidden');
			if (endEl) endEl.classList.add('hidden');

			fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
				.then(function(res) { return res.text(); })
				.then(function(html) {
					const appended = appendPosts(html);
					const currentPage = parseInt(sentinel.getAttribute('data-current-page'), 10) || 1;
					const maxPages = parseInt(sentinel.getAttribute('data-max-pages'), 10) || 1;
					const nextPage = currentPage + 1;
					sentinel.setAttribute('data-current-page', String(nextPage));
					if (appended === 0 || nextPage >= maxPages) {
						done = true;
						if (endEl) endEl.classList.remove('hidden');
					}
				})
				.catch(function() {})
				.finally(function() {
					loading = false;
					if (loadingEl) { loadingEl.classList.add('hidden'); loadingEl.classList.remove('flex'); }
				});
		}

		window.addEventListener('blog-category-filter-updated', function() {
			done = false;
		});

		const observer = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting && !loading && !done) loadNext();
			});
		}, { rootMargin: '200px 0px', threshold: 0 });

		observer.observe(sentinel);
	})();

})();